






import { Component, Vue } from 'nuxt-property-decorator'
import 'swiper/swiper.scss'

@Component
export default class ComponentSliderSwiperSlide extends Vue {}
